export const SliderQcFieldName = 'sliderQcFieldComponent';
